<template>
<header class="header header-two">
			<div class="container">
				<nav class="navbar navbar-expand-lg header-nav">
					<div class="navbar-header">
						<a id="mobile_btn" href="javascript:void(0);">
							<span class="bar-icon">
								<span></span>
								<span></span>
								<span></span>
							</span>
						</a>
						<router-link to="/" class="navbar-brand logo">
							<img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
						</router-link>						
					</div>
					<div class="main-menu-wrapper">
						<div class="menu-header">
							<router-link to="/" class="menu-logo">
								<img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
							</router-link>
							<a id="menu_close" class="menu-close" href="javascript:void(0);"> <i class="fas fa-times"></i></a>
						</div>
						<ul class="main-nav">
							<li class="has-submenu megamenu active">
								<router-link to="/">Home <i class="fas fa-chevron-down"></i></router-link>
								<ul class="submenu mega-submenu">
								    <li>
										<div class="megamenu-wrapper">
											<div class="row">
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="/"><img src="@/assets/img/home-01.jpg" class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="/">Classified Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo active">
														<div class="demo-img">
															<router-link to="index-2"><img src="@/assets/img/home-02.jpg" class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-2">Wedding Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-3"><img src="@/assets/img/home-03.jpg" class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-3">Tour Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-4"><img src="@/assets/img/home-04.jpg" class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-4">Workspace Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-5"><img src="@/assets/img/home-05.jpg"
																	class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-5">Business Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-6"><img src="@/assets/img/home-06.jpg"
																	class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-6">Car Rentals Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-7"><img src="@/assets/img/home-07.jpg"
																	class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-7">Restaurant Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-8"><img src="@/assets/img/home-08.jpg"
																	class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-8">Job Listing Home</router-link>
														</div>
													</div>
												</div>
												<div class="col-lg-2">
													<div class="single-demo">
														<div class="demo-img">
															<router-link to="index-9"><img src="@/assets/img/home-09.jpg"
																	class="img-fluid" alt="img"></router-link>
														</div>
														<div class="demo-info">
															<router-link to="index-9">Realestate Home</router-link>
														</div>
													</div>
												</div>
											</div>
										</div>
									</li>							
								</ul>
							</li>
							<li class="has-submenu">
								<a href="">Listings <i class="fas fa-chevron-down"></i></a>
								<ul class="submenu">
								    <li><router-link to="listing-grid">Listing Grid</router-link></li>
								    <li><router-link to="listing-grid-sidebar">Listing Grid Sidebar</router-link></li>
								    <li><router-link to="listing-list-sidebar">Listing List Sidebar</router-link></li>
								    <li><router-link to="listingmap-list">Listing List Map</router-link></li>
								    <li><router-link to="listingmap-grid">Listing Grid Map</router-link></li>								
								</ul>
							</li>
							<li class="has-submenu">
								<a href="">Pages <i class="fas fa-chevron-down"></i></a>
								<ul class="submenu">
								    <li><router-link to="about">About Us</router-link></li>
								    <li><router-link to="service-details">Service Details </router-link></li>
									<li><router-link to="pricing">Pricing</router-link></li>
									<li><router-link to="faq">FAQ</router-link></li>
									<li><router-link to="gallery">Gallery</router-link></li>
									<li><router-link to="categories">Category</router-link></li>
									<li><router-link to="howitworks">How it Works</router-link></li>
									<li><router-link to="terms-condition">Terms & Conditions</router-link></li>
									<li><router-link to="privacy-policy">Privacy Policy</router-link></li>
									<li><router-link to="error-404">404 Error</router-link></li>
									<li><router-link to="error-500">500 Error</router-link></li>
								</ul>
							</li>
							<li class="has-submenu">
								<a href="">User Pages <i class="fas fa-chevron-down"></i></a>
								<ul class="submenu">
								    <li><router-link to="dashboard">Dashboard</router-link></li>
									<li><router-link to="profile">Profile</router-link></li>
									<li><router-link to="my-listing">My Listing</router-link></li>
                                    <li><router-link to="bookmarks">Bookmarks</router-link></li>									
									<li><router-link to="messages">Messages</router-link></li>									
									<li><router-link to="reviews">Reviews</router-link></li>										
									<li><router-link to="add-listing">Add Listing</router-link></li>										
								</ul>
							</li>
							<li class="has-submenu">
								<a href="">Blog <i class="fas fa-chevron-down"></i></a>
								<ul class="submenu">
								    <li><router-link to="blog-list">Blog List</router-link></li>
									<li><router-link to="blog-grid">Blog Grid</router-link></li>
									<li><router-link to="blog-details">Blog Details</router-link></li>									
									<li><router-link to="blog-list-sidebar">Blog List Sidebar</router-link></li>									
									<li><router-link to="blog-grid-sidebar">Blog Grid Sidebar</router-link></li>																
								</ul>
							</li>
							<li><router-link to="contact">Contact</router-link></li>
							<li class="login-link">
								<router-link to="signup">Sign Up</router-link>
							</li>
							<li class="login-link">
								<router-link to="login">Sign In</router-link>
							</li>
						</ul>
					</div>
					<ul class="nav header-navbar-rht">
						<li class="nav-item">
							<a class="nav-link header-login" href="login">Get Started Now</a>
						</li>
					</ul>
				</nav>
			</div>
		</header>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    mounted() {
        $('body').append('<div class="sidebar-overlay"></div>');
	$(document).on('click', '#mobile_btn', function () {
		$('main-wrapper').toggleClass('slide-nav');
		$('.sidebar-overlay').toggleClass('opened');
		$('html').addClass('menu-opened');
		return false;
	});

	$(document).on('click', '.sidebar-overlay', function () {
		$('html').removeClass('menu-opened');
		$(this).removeClass('opened');
		$('main-wrapper').removeClass('slide-nav');
	});

	$(document).on('click', '#menu_close', function () {
		$('html').removeClass('menu-opened');
		$('.sidebar-overlay').removeClass('opened');
		$('main-wrapper').removeClass('slide-nav');
	});
    },
}
</script>